import React, { useState, useEffect } from "react";

import Button from "../../components/buttons/Button";
import InputField from "../../components/Inputs/InputField";
import Select from "../../components/Inputs/Select";
import * as serviceApi from "../../hooks/useServiceData";
import { useNavigate } from "react-router-dom";
import { GetAccountingPlans } from "../../hooks/useGeneralData";
import Check from "../../components/Inputs/Check";
import { useSnackbar } from "notistack";

export const CreateMaterialModal = (props) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [ownerId, setOwnerId] = useState("");
  const [name, setName] = useState("");
  const [cost, setCost] = useState();
  const [isActive, setIsActive] = useState(true);

  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState();

  const { data } = GetAccountingPlans();

  const { mutate } = serviceApi.CreateMaterial();

  useEffect(() => {
    let accountList = [];
    if (data?.data) {
      accountList = data?.data.map((account) => {
        return {
          value: account.id,
          label: `${account.number} ${account.name}`,
        };
      });
      setAccounts(accountList);
    }
  }, [data]);

  const createMaterial = () => {
    let _material = {};
    _material.owner_id = ownerId;
    _material.name = name;
    _material.cost = cost;
    _material.account = account;
    _material.isActive = isActive;

    mutate(_material, {
      onSuccess: (response) => {
        const materialId = response.data.raw.insertId;
        enqueueSnackbar("Material skapad.", {
          variant: "success",
        });
        navigate(`/registry/material/details/${materialId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Material kunde inte skapas.", {
          variant: "error",
        });
        console.log("ERROR POSTING MATERIAL: ", error);
      },
    });
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          createMaterial();
        }}
        className="container"
        style={{ width: "100%" }}
      >
        <InputField
          required
          type="text"
          label="Namn"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputField
          required
          type="text"
          label="Ange ID"
          value={ownerId}
          onChange={(e) => setOwnerId(e.target.value)}
        />
        <InputField
          required
          type="number"
          label="Ange Kostnad"
          value={cost}
          onChange={(e) => setCost(e.target.value)}
        />
        <Select
          required
          options={accounts}
          label={"Ange Kontoplan"}
          onChange={(event, item) => setAccount(item.value)}
        />
        <div className="create-active-check-container">
          <Check
            color="success"
            label="Aktiv"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
        </div>
        <div className="rightAlign-button-container">
          <Button type="submit" color="success">Skapa Material</Button>
          <Button
            variant="outlined"
            onClick={() => props.closeCreateModal()}
          >
            Stäng
          </Button>
        </div>
      </form>
    </>
  );
};
